export default function RetentionPolicy() {
  return (
    <div style={{ padding: "1.5rem", maxWidth: "900px" }}>
      <h1>Data Retention Policy (Draft)</h1>

      <h2>Plain language summary</h2>
      <p>
        We keep data only for as long as the pilot requires. Most classroom data is kept while
        the class is active and archived or deleted after the pilot ends. Feedback and analytics
        are kept for shorter periods to support improvement.
      </p>

      <h2>1. Purpose</h2>
      <p>This policy describes how long we retain data in the app during the pilot.</p>

      <h2>2. Retention schedule (suggested defaults)</h2>
      <ul>
        <li>User accounts (users): keep while the user needs access; remove within 90 days after account deactivation</li>
        <li>Classes (classes): keep while the class is active; archive or delete within 12 months after class ends</li>
        <li>Students (classes/{"id"}/students): keep while class is active; delete within 12 months after class ends (includes SEN status/detail and pupil premium indicator where stored)</li>
        <li>Seating plans and layouts (seatingPlan, deskLayouts): keep while class is active; delete with class</li>
        <li>Behaviour events (events): keep while class is active; delete within 12 months after class ends</li>
        <li>Learning objectives (objectives): keep while class is active; delete within 12 months after class ends</li>
        <li>Attendance (attendance): keep while class is active; delete within 12 months after class ends</li>
        <li>Feedback (feedback): keep 12 months after submission or until resolved + 6 months</li>
        <li>Usage analytics (analyticsEvents): keep 6 months for trend reporting</li>
      </ul>

      <h2>3. Deletion and archiving</h2>
      <ul>
        <li>Data is deleted or archived at the end of the retention period</li>
        <li>Admins can archive feedback manually</li>
        <li>Bulk deletion can be performed at the end of pilot by the project owner</li>
      </ul>

      <h2>4. Minimisation and accuracy</h2>
      <ul>
        <li>We only collect data for specified, explicit, and legitimate reasons</li>
        <li>Staff should only process data needed for their role</li>
        <li>Data should be kept accurate and corrected or erased when needed</li>
        <li>When data is no longer needed, it should be deleted or anonymised in line with the trust record retention schedule</li>
      </ul>

      <h2>5. Disposal of records</h2>
      <ul>
        <li>Data no longer needed, inaccurate, or out of date is disposed of securely</li>
        <li>Paper records are shredded or incinerated; electronic files are overwritten or deleted</li>
        <li>Third-party disposal services must provide sufficient guarantees of compliance</li>
      </ul>
      <p>For subject access requests (SARs) and sharing/disclosure details, see the Privacy Notice.</p>

      <h2>6. Exceptions</h2>
      <p>
        Legal or policy requirements may require longer retention. Any exceptions should be
        documented here.
      </p>

      <h2>7. Review</h2>
      <p>This policy should be reviewed at the end of the pilot and before production rollout.</p>

      <p style={{ marginTop: "1.5rem", fontStyle: "italic" }}>
        Disclaimer: This draft is not legal advice and should be reviewed by the school's data
        protection lead.
      </p>
    </div>
  );
}
